import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Login: React.FC = () => {
  const { login, error, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation(); // Get location object
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!username || !password) {
      return;
    }
    
    try {
      await login(username, password);
      // Determine redirect path
      const fromPath = location.state?.from?.pathname || '/dashboard';
      console.log('Login: Redirecting after successful login to:', fromPath);
      navigate(fromPath, { replace: true }); // Use the original path or default to dashboard
    } catch (error) {
      // Error is handled in the AuthContext
      console.error('Login failed:', error);
    }
  };

  return (
    <div>
      <h2 className="text-center text-2xl font-bold mb-6">Вход в систему</h2>
      
      {error && (
        <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md">
          {error}
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="username" className="form-label">
            Имя пользователя
          </label>
          <input
            id="username"
            name="username"
            type="text"
            required
            className="form-input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Введите имя пользователя"
          />
        </div>

        <div>
          <label htmlFor="password" className="form-label">
            Пароль
          </label>
          <input
            id="password"
            name="password"
            type="password"
            required
            className="form-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Введите пароль"
          />
        </div>

        <div>
          <button
            type="submit"
            className="btn-primary w-full"
            disabled={loading}
          >
            {loading ? 'Выполняется вход...' : 'Войти'}
          </button>
        </div>
      </form>
      
    </div>
  );
};

export default Login;
